

exports.__esModule = true;
exports.$AddressNormalizationRoute = void 0;
var _squid = require("squid");
require("./directive");
var $AddressNormalizationRoute = exports.$AddressNormalizationRoute = _squid.$ComponentRoute.extend('AddressNormalizationRoute', {
  name: 'addressNormalization',
  titleContent: 'addressNormalization.addressmatch',
  directive: 'xo-address-normalization',
  trackingData: {
    fptiState: 'address_normalization',
    buzname: {
      'fullpage': {
        'pagename': '%::address_normalization',
        'pagename2': '%::address_normalization:member:hermes:',
        'version': 'member:%:'
      }
    }
  },
  loginRequired: true,
  children: []
});
angular.value("$AddressNormalizationRoute", $AddressNormalizationRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-address-components/src/address-normalization/route.js
// module id = ../node_modules/xo-address-components/src/address-normalization/route.js
// module chunks = 0